import { useEffect, useState } from 'react';
import { getFilterValue, useDoctorAvailabilityFilter } from '@medifind/zustand';
import styles from './SchedulesOnlineDisclaimer.module.scss';

const SchedulesOnlineDisclaimer = () => {
  return (
    <div className={styles['disclaimer__container']}>
      <div className={styles['disclaimer__text']}>
        The providers beyond this point do not provide online scheduling options. You can call the providers directly to schedule with them
        or try expanding other filters to see more results.
      </div>
    </div>
  );
};
const useSchedulesOnlineDisclaimerPosition = ({ featuredResults = [], results }) => {
  const [schedulesOnlineDisclaimerPosition, setSchedulesOnlineDisclaimerPosition] = useState(-1);
  const doctorAvailability = useDoctorAvailabilityFilter(getFilterValue);

  useEffect(() => {
    if (results && doctorAvailability.includes('appointmentAssistOptIn')) {
      const featuredI = featuredResults.findIndex((doctor) => !doctor.appointmentAssistOptIn);
      const resultsI = results.findIndex((doctor) => !doctor.appointmentAssistOptIn);
      let i;
      if (featuredI !== -1 && resultsI === -1) i = resultsI;
      else if (featuredI !== -1) i = featuredI;
      else if (featuredI === -1 && resultsI !== -1) {
        i = resultsI;
        if (i !== -1) i += featuredResults.length;
      }

      setSchedulesOnlineDisclaimerPosition(i);
    } else {
      setSchedulesOnlineDisclaimerPosition(-1);
    }
  }, [results, doctorAvailability]);

  return schedulesOnlineDisclaimerPosition;
};
export { SchedulesOnlineDisclaimer as default, SchedulesOnlineDisclaimer, useSchedulesOnlineDisclaimerPosition };
